<script>
/** Type mighty be : default (or null), highlight, overlay**/
export default {
  props: ["text"],
  methods: {},
};
</script>

<template>
  <div class="f-tooltip-container">
    <slot></slot>

    <div v-if="text" class="f-tooltip-tooltip">
      <span v-html="text"></span>
    </div>
  </div>
</template>

<style lang="scss">
.f-tooltip-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;

  .f-tooltip-tooltip {
    display: none;
    position: absolute;
    left: 100%;
    margin-left: 20px;
    white-space: nowrap;
    background-color: rgba(22, 22, 21, 0.9);
    padding: 11px;
    border-radius: 6px;
    border: none;
    font-size: 14px;
    color: #fff;
    text-align: left;
    z-index: 1;
    backdrop-filter: blur(4px);
    font-family: Lato;
    font-weight: 500;
    align-items: center;

    .f-tooltip-icon {
      margin-right: 11px;
      font-size: 18px;
    }
  }

  &:hover .f-tooltip-tooltip {
    display: flex;
  }

  .f-tooltip-tooltip:after {
    content: "";
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 10px 10px 10px 0;
    border-color: transparent rgba(22, 22, 21, 0.9) transparent transparent;
    position: absolute;
    top: 50%;
    margin-top: -10px;
    left: -10px;
  }
}

.dark-mode {
  .f-tooltip-container {
    .f-tooltip-tooltip {
      .f-tooltip-icon {
      }
    }

    &:hover .f-tooltip-tooltip {
    }

    .f-tooltip-tooltip:after {
    }
  }
}
</style>